import React from 'react'
import Stats from './modules/Stats'

const StatsContainer = () => {
  return (
    <Stats />
  )
}

export default StatsContainer